// Display text for a result-chip label ('pass'/'fail'/'incomplete'/
// 'corrected'/'void'). 'pass'/'fail'/'incomplete'/'corrected' are real
// English words already, rendered verbatim -- the badge's own CSS
// (text-transform: capitalize) title-cases them. Only 'void' routes through
// translation, since section 6 treats it as a distinct, product-facing state
// rather than a raw API value.
//
// Lives in its own leaf module (rather than in InspectRecords.js, where the
// History column's own resultChipInfo/resultLabelText usage lives) because
// InspectDeficiencyDialogs.js's Activity Log status chips need this exact
// "void" mapping too, and InspectRecords.js already imports dialogs FROM
// InspectDeficiencyDialogs.js -- importing the reverse direction would
// cycle. A shared leaf neither of those files needs to import from the
// other breaks that cleanly.
// The neutral marker chips that qualify a result chip, in display order:
// Manual (a person marked the result) then Amended. Shared by the History
// column and the Activity Log so both read the same, and so the app's
// InspectionResultChip matches them.
export function markerBadgeText(marker, t) {
  if (marker === 'manual') return t('inspect:manualBadge', 'Manual');
  if (marker === 'amended') return t('inspect:amendedBadge', 'Amended');
  return marker;
}

export function resultLabelText(label, t) {
  if (label === 'void') return t('inspect:voidBadge', 'Void');
  return label;
}
